/**
 * MD-14 FE-LANDINGS - /sme landing copy (VN-first compliance/thuế/hợp đồng)
 *
 * Reference: STRATEGY Sec.4 + LinkedIn channel deeplink target.
 */

import type { LandingCatalog } from './landing-types';

export const smeVi: LandingCatalog<'vi'> = {
  meta_title: 'Asklaw cho doanh nghiệp SME - thuế, hợp đồng, lao động',
  meta_description:
    'Trợ lý pháp lý AI cho SME Việt Nam: thuế GTGT/TNDN, hợp đồng lao động, đăng ký kinh doanh, bảo hiểm xã hội.',
  hero_eyebrow: 'Cho SME Việt Nam',
  hero_headline: 'Thuế, hợp đồng, lao động - trích dẫn Điều/Khoản chính xác',
  hero_subhead:
    'Asklaw trả lời các câu hỏi tuân thủ pháp luật cho SME: thuế GTGT/TNDN, hợp đồng lao động, BHXH, đăng ký kinh doanh - kèm trích dẫn từ VBPL chính thức.',
  cta_primary: 'Hỏi ngay',
  cta_secondary: 'Xem Doc Pack SME',
  feature_1_title: 'Thuế GTGT và TNDN',
  feature_1_body:
    'Luật Thuế GTGT, Luật Thuế TNDN cùng các Nghị định và Thông tư hướng dẫn. Cập nhật thay đổi mới nhất.',
  feature_2_title: 'Hợp đồng lao động',
  feature_2_body:
    'Bộ luật Lao động 2019 và Nghị định 145/2020/NĐ-CP. Chấm dứt hợp đồng, sa thải, thai sản.',
  feature_3_title: 'Đăng ký kinh doanh',
  feature_3_body:
    'Luật Doanh nghiệp 2020 và Nghị định 01/2021/NĐ-CP. Thay đổi giấy phép kinh doanh, mua bán sáp nhập, giải thể.',
  pricing_intro: 'Hỏi miễn phí. Doc Pack SME từ 199.000đ. Gói Pro sắp ra mắt.',
  footer_disclaimer:
    'Asklaw là công cụ AI tham khảo thông tin pháp luật, KHÔNG phải dịch vụ tư vấn pháp lý. ' +
    'Mọi kết quả do AI tạo, có thể sai sót. Để được tư vấn chính thức cho vụ việc cụ thể, ' +
    'vui lòng liên hệ luật sư có chứng chỉ hành nghề.',
};

export const smeEn: LandingCatalog<'en'> = {
  meta_title: 'Asklaw for Vietnamese SMEs - tax, contract, labor',
  meta_description:
    'AI Legal Copilot for Vietnamese SMEs: VAT/CIT, employment contracts, business registration, social insurance.',
  hero_eyebrow: 'For Vietnamese SMEs',
  hero_headline: 'Tax, contract, labor - accurate Article/Clause citations',
  hero_subhead:
    'Asklaw answers SME compliance questions: VAT/CIT, employment contracts, social insurance, business registration - with citations from the official VBPL corpus.',
  cta_primary: 'Ask now',
  cta_secondary: 'See SME Doc Packs',
  feature_1_title: 'VAT + Corporate Income Tax',
  feature_1_body:
    'Law on VAT, Law on CIT, decrees and circulars. Latest updates included.',
  feature_2_title: 'Employment contracts',
  feature_2_body:
    'Labor Code 2019 + Decree 145/2020/NĐ-CP. Termination, dismissal, maternity.',
  feature_3_title: 'Business registration',
  feature_3_body:
    'Law on Enterprises 2020 + Decree 01/2021/NĐ-CP. License changes, M&A, dissolution.',
  pricing_intro: 'Free chat. SME Doc Pack from 199,000 VND. Pro tier coming soon.',
  footer_disclaimer:
    'Asklaw is an AI tool for legal information reference only, NOT a legal advisory service. ' +
    'All outputs are AI-generated and may contain errors. For formal advice on specific matters, ' +
    'please consult a licensed Vietnamese lawyer.',
};
